module.exports = __webpack_public_path__ + "img/09.9e0fe012.jpg";